module.exports = __webpack_public_path__ + "media/images/partners/wizart-17ad358ef5fa3650cec1a1ebbf6386cd.png";